import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/couriers', { params }),

  sync: () => axios.put('/api/admin/v1/couriers', {}),
}
